import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import secureLocalStorage from "react-secure-storage";
import { MyContext } from "../../Context/MyProvider";
import Payment from "../../Payment/Payment";
import { continueAfterGateway } from "../../utils/paymentResult";

export default function PayAppPartner() {
  const { id } = useParams();
  const { ApiBaseUrl, setIsLoginShow, paymentStatus, setPaymentStatus, transactionid } = useContext(MyContext);
  const Userid = secureLocalStorage.getItem("Userid");
  const [partner, setPartner] = useState(null);
  const [bill, setBill] = useState("");
  const [offers, setOffers] = useState([]);
  const [offerId, setOfferId] = useState("");
  const [txn, setTxn] = useState(null);
  const [showPay, setShowPay] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${ApiBaseUrl}/pv/customer/partner/${id}`).then((r) => setPartner(r.data.partner));
  }, [id, ApiBaseUrl]);

  useEffect(() => {
    if (!bill || Number(bill) <= 0) return;
    axios.post(`${ApiBaseUrl}/pv/customer/offers/preview`, {
      partner_profile_id: id, customer_id: Userid || 0, bill_amount: bill
    }).then((r) => {
      setOffers((r.data.offers || []).filter((o) => !o.ineligible));
    });
  }, [bill, id, Userid, ApiBaseUrl]);

  useEffect(() => {
    if (paymentStatus !== "PaymentDone" && paymentStatus !== "PaymentFaild") return;
    setPaymentStatus("");
    if (paymentStatus === "PaymentFaild") {
      continueAfterGateway(navigate, { success: false, cancelled: true, transactionId: "0" });
      return;
    }
    continueAfterGateway(navigate, { success: true, transactionId: transactionid || "" });
  }, [paymentStatus, navigate, transactionid, setPaymentStatus]);

  const createTxn = async () => {
    if (!Userid) { setIsLoginShow(true); return; }
    if (!bill || Number(bill) <= 0) return toast.error("Enter bill amount");
    const res = await axios.post(`${ApiBaseUrl}/pv/customer/txn/create`, {
      customer_id: Userid,
      partner_profile_id: id,
      offer_id: offerId || null,
      original_bill: bill,
      mode: "walk_in"
    });
    if (!res.data.Result) return toast.error(res.data.message);
    toast.success("Transaction created");
    setTxn(res.data.txn);
    sessionStorage.setItem("page", "5");
    sessionStorage.setItem("PaymentData", JSON.stringify({
      txn_id: res.data.txn.id,
      customer_id: Userid,
      amount: res.data.txn.payable_amount
    }));
    setShowPay(true);
  };

  if (!partner) return <div className="p-10 text-center">Loading...</div>;
  const selected = offers.find((o) => String(o.offer.id) === String(offerId));

  return (
    <div className="max-w-2xl mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold text-rm-ink">{partner.display_name}</h1>
      <p className="text-gray-600 mb-6">{partner.category_name || partner.partner_type}</p>

      <label className="block mb-4">Bill amount (₹)
        <input type="number" className="border rounded w-full px-3 py-2 mt-1" value={bill} onChange={(e) => setBill(e.target.value)} />
      </label>

      {offers.length > 0 && (
        <div className="mb-4 space-y-2">
          <p className="font-semibold">Available offers</p>
          <label className="flex gap-2 items-center border rounded p-3">
            <input type="radio" name="offer" checked={!offerId} onChange={() => setOfferId("")} /> No offer
          </label>
          {offers.map((o) => (
            <label key={o.offer.id} className="flex gap-2 items-start border rounded p-3 cursor-pointer">
              <input type="radio" name="offer" checked={String(offerId) === String(o.offer.id)} onChange={() => setOfferId(o.offer.id)} />
              <div>
                <p className="font-medium">{o.offer.name}</p>
                <p className="text-sm text-gray-600">Save ₹{o.discount_amount} · Pay ₹{o.payable_amount}</p>
              </div>
            </label>
          ))}
        </div>
      )}

      {selected && (
        <p className="mb-4 font-bold text-green-700">Estimated payable: ₹{selected.payable_amount}</p>
      )}

      {!showPay ? (
        <button className="w-full bg-rm-primary text-white py-3 rounded font-semibold" onClick={createTxn}>Continue to pay</button>
      ) : (
        <div className="border rounded-xl p-4">
          <h3 className="font-semibold mb-3">Pay ₹{txn?.payable_amount}</h3>
          <Payment Amount={txn?.payable_amount} Data={{ txn_id: txn.id, customer_id: Userid, amount: txn.payable_amount }} />
        </div>
      )}
    </div>
  );
}
